import React, { useEffect, useState } from 'react';

/**
 * Приветственный баннер для новых пользователей, пришедших по реферальной ссылке
 * Показывается один раз при первом переходе по ссылке
 * После показа сохраняется в localStorage, чтобы больше не появляться
 */
const WelcomeBanner = ({ telegramUser, balance }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [referrerName, setReferrerName] = useState('');
  const [bonus, setBonus] = useState(100);

  useEffect(() => {
    if (!telegramUser?.id || !balance) return;

    // Проверяем, был ли уже показан баннер этому пользователю
    const bannerShownKey = `welcome_banner_shown_${telegramUser.id}`;
    const bannerAlreadyShown = localStorage.getItem(bannerShownKey);

    if (bannerAlreadyShown) {
      return; // Баннер уже был показан
    }

    // Проверяем, есть ли welcome_bonus транзакция в истории
    if (balance.recent_transactions && balance.recent_transactions.length > 0) {
      const welcomeBonus = balance.recent_transactions.find(
        tx => tx.transaction_type === 'welcome_bonus'
      );

      if (welcomeBonus) {
        // Нашли приветственный бонус - показываем баннер
        setBonus(welcomeBonus.amount);
        // Можно попробовать извлечь имя реферера из description
        // Пример: "Приветственный бонус за переход по реферальной ссылке"
        // (имя реферера не хранится в транзакции, используем общее сообщение)
        setReferrerName('организатора');
        setIsVisible(true);

        // Отмечаем, что баннер был показан
        localStorage.setItem(bannerShownKey, 'true');

        // Автоматически скрываем баннер через 8 секунд
        setTimeout(() => {
          handleClose();
        }, 8000);
      }
    }
  }, [telegramUser, balance]);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 animate-slide-down">
      <div
        className="mx-4 mt-4 backdrop-blur-[16px] bg-gradient-to-br from-green-50/[0.95] to-emerald-50/[0.90] dark:from-green-900/[0.30] dark:to-emerald-900/[0.25] rounded-2xl p-4 border-2 border-green-400/[0.30] dark:border-green-500/[0.25] shadow-[0_12px_40px_rgba(16,185,129,0.25),inset_0_1px_0_rgba(255,255,255,0.3)]"
        style={{
          WebkitBackdropFilter: 'blur(16px)',
          backdropFilter: 'blur(16px)',
        }}
      >
        <div className="flex items-start justify-between gap-2 sm:gap-3">
          <div className="flex items-start gap-2 sm:gap-3 flex-1">
            <span className="text-2xl sm:text-3xl">🎁</span>
            <div className="flex-1">
              <div className="font-bold text-green-800 dark:text-green-200 text-sm sm:text-base mb-0.5 sm:mb-1">
                Поздравляем!
              </div>
              {/* Десктоп версия */}
              <div className="hidden sm:block text-sm text-gray-700 dark:text-gray-300 leading-relaxed">
                Вы пришли по приглашению от {referrerName}.<br />
                Вам начислен приветственный бонус <span className="font-bold text-green-700 dark:text-green-300">{bonus}₽</span>!<br />
                <span className="text-xs text-gray-600 dark:text-gray-400 mt-1 block">
                  Используйте его при первом заказе 💰
                </span>
              </div>
              {/* Мобильная версия */}
              <div className="block sm:hidden text-xs text-gray-700 dark:text-gray-300 leading-snug">
                Бонус от {referrerName}: <span className="font-bold text-green-700 dark:text-green-300">{bonus}₽</span>
                <span className="text-[10px] text-gray-600 dark:text-gray-400 block mt-0.5">
                  Используйте при первом заказе 💰
                </span>
              </div>
            </div>
          </div>
          <button
            onClick={handleClose}
            className="shrink-0 w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
            aria-label="Закрыть"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBanner;
